export default "__VITE_ASSET__D6pBg4rY__"